import React from "react";
import MainContainer from "./components/mainContainer/index";

// TODO: turning hot spots off and on
// TODO: stands => instead of {value: 1}, change to just 1

const App = (props) => <MainContainer props={props.props.props} />;

export default App;
